import backofficeApi from './backoffice-api';

const CATALOG_PATH = '/catering/packaging/catalog';
const BACKOFFICE_TOKEN_KEY = 'token_backoffice';
const BACKOFFICE_TOKEN_HEADER = 'X-Backoffice-Token';
const BEARER_PREFIX = 'Bearer ';
const MISSING_SESSION = 'The backoffice session token is missing';

function readBackofficeToken() {
  return window.localStorage.getItem(BACKOFFICE_TOKEN_KEY) || '';
}

export function backofficeTokenHeader() {
  return { [BACKOFFICE_TOKEN_HEADER]: readBackofficeToken() };
}

export default {
  fetchCatalog() {
    const token = readBackofficeToken();
    if (!token) return Promise.reject(new Error(MISSING_SESSION));

    return backofficeApi
      .get(CATALOG_PATH, { headers: { Authorization: BEARER_PREFIX + token } })
      .then(({ data }) => data.data);
  },
};
